import React, { FC } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { IGameVersion } from '../../../model/gameVersion/GameVersion';
import { GameVersionCard } from './GameVersionCard';
import { PublisherViewHeader } from '../../components/publisher-view-header/publisher-view-header';
import { FloatingActionButton } from '@yakoffice/floating-actions';
import { GameVersionsOverviewCard } from './gameVersionsOverviewCard';
import { NewGameVersionCard } from './newGameVersionCard';
import style from '../../components/tables/filters/table-filters.module.sass';
import filterIcon from '../../components/tables/filters/filter_list.svg';
import { GameVersionStatus } from '@yakoffice/publisher-types';
import { runInAction } from 'mobx';


interface PropsType {
    gameVersions: IGameVersion[];
    updateCallbackTrigger: () => void;
    activeGameVersion?: IGameVersion | null;
    setActiveGameVersion: (gameVersion: IGameVersion | undefined) => void;
    newGameVersion: boolean;
    setNewGameVersion: (value: boolean) => void;
}


export const GameVersions: FC<PropsType> = observer((props) => {

    const getFilters = (): GameVersionStatus[] => {

        const gameVersionFilters = [GameVersionStatus.Live, GameVersionStatus.Unreleased, GameVersionStatus.Inactive, GameVersionStatus.Archived];

        if (localStorage.getItem(`GameVersionFilter-${GameVersionStatus.Live}`) === 'false')
            gameVersionFilters.splice(gameVersionFilters.indexOf(GameVersionStatus.Live), 1);

        if (localStorage.getItem(`GameVersionFilter-${GameVersionStatus.Unreleased}`) === 'false')
            gameVersionFilters.splice(gameVersionFilters.indexOf(GameVersionStatus.Unreleased), 1);

        if (localStorage.getItem(`GameVersionFilter-${GameVersionStatus.Inactive}`) === 'false')
            gameVersionFilters.splice(gameVersionFilters.indexOf(GameVersionStatus.Inactive), 1);

        if (localStorage.getItem(`GameVersionFilter-${GameVersionStatus.Archived}`) === 'false')
            gameVersionFilters.splice(gameVersionFilters.indexOf(GameVersionStatus.Archived), 1);

        return gameVersionFilters;
    };

    const statusStore = useLocalObservable(() => ({
        statusFilters: getFilters() as string[]
    }));

    const updateCallbackTrigger = (clearActiveGameVersion?: boolean) => {
        props.updateCallbackTrigger();
        clearActiveGameVersion && props.setActiveGameVersion(undefined);
    };

    const updateNewGameVersionCallback = (clearActiveGameVersion?: boolean) => {
        props.updateCallbackTrigger();
        clearActiveGameVersion && props.setActiveGameVersion(undefined);
        props.setNewGameVersion(false);
    };

    const createNewGameVersion = () => {
        props.setActiveGameVersion(undefined);
        props.setNewGameVersion(true);
    };

    const handleStatusToggle = (status: string) => {
        runInAction(() => {
            const index = statusStore.statusFilters.indexOf(status);
            if (index >= 0) {
                statusStore.statusFilters.splice(index, 1);
                window.localStorage.setItem(`GameVersionFilter-${status}`, 'false');
            } else {
                statusStore.statusFilters.push(status);
                window.localStorage.setItem(`GameVersionFilter-${status}`, 'true');
            }
        });
    };

    return <div id="gameVersions">
        <PublisherViewHeader title="Game Versions" />

        <Container fluid>
            <div className={style.tableFilters}>
                <img src={filterIcon} alt="" className={style.filterIcon} />
                {[GameVersionStatus.Live, GameVersionStatus.Inactive, GameVersionStatus.Unreleased, GameVersionStatus.Archived].map(status => {
                    return status.length > 0 && <div key={`toggle-${status}`}
                                                     className={`${style.status} ${statusStore.statusFilters.includes(status) ? style.active : style.inactive}`}
                                                     onClick={() => handleStatusToggle(status)}>{statusStore.statusFilters.includes(status) &&
                        <i className="fas fa-check" />}
                        {status}</div>;
                })}
            </div>
        </Container>
        <Container fluid>
            <Row>
                <Col xl={4} lg={5} md={6} className="scrollable">
                    {props.gameVersions.filter(gameVersion => statusStore.statusFilters.includes(gameVersion.status))
                        .map(gameVersion =>
                            <div onClick={() => {
                                props.setNewGameVersion(false);
                                props.setActiveGameVersion(gameVersion);
                            }} key={gameVersion.id}>
                                <GameVersionsOverviewCard gameVersion={gameVersion}
                                                          active={props.activeGameVersion === gameVersion} />
                            </div>
                        )}
                </Col>
                <Col xl={8} lg={7} md={6} className="">
                    <div className="">
                        {props.activeGameVersion &&
                            <GameVersionCard gameVersion={props.activeGameVersion}
                                             updateCallbackTrigger={updateCallbackTrigger} />}
                        {props.newGameVersion &&
                            <NewGameVersionCard updateCallbackTrigger={updateNewGameVersionCallback} />}
                    </div>
                </Col>
            </Row>
            <FloatingActionButton callback={createNewGameVersion}
                                  buttonContent={<><i className="fas fa-plus font-light me-2" /> New Version</>} />
        </Container>
    </div>;
});
